<div *ngIf="transactionForm" class="form-modal">
  <h1 mat-dialog-title>{{'TRANSITION'|translate}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="transactionForm" class="form-horizontal">
      <div class="form-group">

        <!-- Panel base -->
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-body no-horizontal-padding">
              <div class="form-group">
                <!-- Do Estado -->
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-select placeholder="{{'FROM_STATE'|translate}}" formControlName="FromStateID" [ngClass]="{ 'mat-input-invalid': formErrors.FromStateID }">
                      <!--<mat-option value=''></mat-option>-->
                      <mat-option *ngFor="let state of statesList" [value]="state.ID">{{state.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.FromStateID" class="font75per" [translate]
                    [translateParams]="formErrorsParam.FromStateID">{{
                    formErrors.FromStateID }}</mat-error>
                </div>
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Para Estado -->
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-select placeholder="{{'TO_STATE'|translate}}" formControlName="ToStateID" [ngClass]="{ 'mat-input-invalid': formErrors.ToStateID }">
                      <!--<mat-option value=''></mat-option>-->
                      <mat-option *ngFor="let state of statesList" [value]="state.ID">{{state.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.ToStateID" class="font75per" [translate]
                    [translateParams]="formErrorsParam.ToStateID">{{
                    formErrors.ToStateID }}</mat-error>
                </div>
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Ação -->
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': formErrors.ActionVerb }">
                    <input matInput placeholder="{{ 'ACTION_NAME' | translate}}" formControlName="ActionVerb">
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.ActionVerb" class="font75per" [translate]
                    [translateParams]="formErrorsParam.ActionVerb">{{
                    formErrors.ActionVerb }}</mat-error>
                </div>
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Checkbox criador pode efetuar ação -->
                <div class="col-md-12 col-sm-12" style="padding-top:5px">
                  <mat-checkbox class="allwidth" formControlName="AllowCreator">Permitir ao utilizador que criou o documento</mat-checkbox>
                </div>
                
              </div>
            </div>
          </div>
        </div>

        <!-- Panel da Tabela de Utilizadores -->
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup1" (click)="collPnPopup1 = !collPnPopup1">
              <h5 class="panel-title">
                <i class="fas fa-users"></i>
                <strong>{{'USERS'|translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPnPopup1, 'fa-caret-up': !collPnPopup1}"></i>
              </h5>
            </div>
            <div id="collPnPopup1" class="panel-body no-horizontal-padding collapse in">
              <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup2"
                (click)="collPnPopup2 = !collPnPopup2">
                <h5 class="panel-title">
                  <i class="fas fa-users"></i>
                  <strong> {{'PROFILES'|translate}}</strong>
                  <i class="collapse-icon fas"
                    [ngClass]="{'fa-caret-down': collPnPopup2, 'fa-caret-up': !collPnPopup2}"></i>
                </h5>
              </div>
              <div id="collPnPopup2" class="panel-body no-horizontal-padding collapse in">
                <table id="tabelaWorkflowUsersProfiles" class="table table-bordered display" cellspacing="0">
                  <thead>
                    <tr>
                      <th>
                        <strong>{{ 'NAME'| translate}}</strong>
                      </th>
                      <th></th>
                    </tr>
                    <tr>
                      <th>
                        <mat-form-field class="full-width findInputContainer">
                          <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput">
                        </mat-form-field>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
              <table id="tabelaWorkflowUsers" class="table table-bordered display" cellspacing="0">
                <thead>
                  <tr>
                    <th>
                      <strong>{{ 'NAME'| translate}}</strong>
                    </th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>
                      <mat-form-field class="full-width findInputContainer">
                        <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput">
                      </mat-form-field>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Panel da Tabela de Aprovadores -->
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup4"
              (click)="collPnPopup4 = !collPnPopup4">
              <h5 class="panel-title">
                <i class="fas fa-users"></i>
                <strong> {{'APPROVATION'|translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup4, 'fa-caret-up': !collPnPopup4}"></i>
              </h5>
            </div>
            <div id="collPnPopup4" class="panel-body no-horizontal-padding collapse in">
              <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup5"
                  (click)="collPnPopup5 = !collPnPopup5">
                  <h5 class="panel-title">
                    <i class="fas fa-users"></i>
                    <strong> {{'PROFILES'|translate}}</strong>
                    <i class="collapse-icon fas"
                      [ngClass]="{'fa-caret-down': collPnPopup5, 'fa-caret-up': !collPnPopup5}"></i>
                  </h5>
              </div>
              <div id="collPnPopup5" class="panel-body no-horizontal-padding collapse in">
                <table id="tabelaWorkflowApproversProfiles" class="table table-bordered display" cellspacing="0">
                  <thead>
                    <tr>
                      <th>
                        <strong>{{ 'NAME'| translate}}</strong>
                      </th>
                      <th></th>
                    </tr>
                    <tr>
                      <th>
                        <mat-form-field class="full-width findInputContainer">
                          <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput">
                        </mat-form-field>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
            <div id="collPnPopup2" class="panel-body no-horizontal-padding collapse in">
              <table id="tabelaWorkflowApprovers" class="table table-bordered display" cellspacing="0">
                <thead>
                  <tr>
                    <th>
                      <strong>{{ 'NAME'| translate}}</strong>
                    </th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>
                      <mat-form-field class="full-width findInputContainer">
                        <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput">
                      </mat-form-field>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" (click)="resetForm();dialogRef.close(null)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
      </button>
      <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!transactionForm.valid">
        <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
      </button>
    </div>
  </div>
</div>